import { LinkContext } from "../LinkProvider";
import { useContext } from "react";

import { useTranslation } from "react-i18next";

function Button ( { className, main } ) {

    const { link } = useContext(LinkContext);
    
    const { t } = useTranslation();
      
    return(
        <div className={className}>
            <a href={link}>
                <div className={`flex cursor-pointer hover:scale-[0.9] transition-all gap-[18px] items-center rounded-[60px] ${main === true ? 'border-[#FFFFFF]' : 'border-[#000000]'} border`}>
                    <svg className={`ml-[4px] my-[4px] ${main === true ? '' : 'hidden'}`} xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
                        <rect width="42" height="42" rx="21" fill="white"/>
                        <path d="M12.3529 21H29.6471" stroke="black" stroke-width="1.10526" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M21 12.353L29.6471 21L21 29.6471" stroke="black" stroke-width="1.10526" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <svg className={`ml-[4px] my-[4px] ${main === true ? 'hidden' : ''}`} xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42" fill="none">
                        <rect width="42" height="42" rx="21" fill="#17171F"/>
                        <path d="M12.3529 21H29.6471" stroke="white" stroke-width="1.10526" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M21 12.353L29.6471 21.0001L21 29.6471" stroke="white" stroke-width="1.10526" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                    <p className={`${main === true ? 'text-white' : 'text-black'} mr-[20px] roboto leading-[1.4]`}>{t('home.2')}</p>
                </div>
            </a>
        </div>
    );
}

export default Button;